import React from 'react';
import { RecipeTable } from '../../../enums/RecipeTable';
import { RecipeType } from '../../../enums/RecipeType';
import { strings } from '../../../resources/strings';
import { Session } from '../../../models/Session';
import { Frame } from '../../../models/Frame';
import { DiagnosticInformation } from '../../../models/DiagnosticInformation';
import { MultifocalInfo } from '../../../models/MultifocalInfo';
import { TabItem } from '../../../common-components/TabMenu/styles';
import { TabMenu } from '../../../common-components/TabMenu/TabMenu';
import { CommonData } from './CommonData/CommonData';
import { TabDiagnostic } from './TabDiagnostic/TabDiagnostic';
import { TabMultifocal } from './TabMultifocal/TabMultifocal';
import { BodyContainer } from './styles';

export class FormRecipeValues {
  id?: number;
  name?: string;
  description?: string;
  pathToFile?: string;
  recipeApproved: boolean = false;
  nasoPupillaryDistanceApproved: boolean = false;
  farDiagnostic?: DiagnosticInformation;
  nearDiagnostic?: DiagnosticInformation;
  recipeType?: RecipeType;
  multifocalInfo?: MultifocalInfo;
  multifocalInfoIsConfirmed: boolean;
  leftEyeHeight?: number | null;
  rightEyeHeight?: number | null;
}

const TabOptions = {
  Diagnostic: 'tab-diagnostic',
  Muiltifocal: 'tab-multifocal'
}

interface IRegisterRecipeFormProps {
  orderId?: number;
  orderNumber?: string;
  recipeTable: RecipeTable;
  session?: Session | null;
  frames?: Frame[];
  values?: FormRecipeValues;
  change: (values: FormRecipeValues) => void;
}

const RegisterRecipeForm: React.FC<IRegisterRecipeFormProps> = ({
  orderId,
  orderNumber,
  recipeTable,
  session,
  frames,
  values,
  change,
}) => {

  const [activeTab, setActiveTab] = React.useState<string>(TabOptions.Diagnostic);

  const header = React.useMemo(() => {
    return <CommonData
            recipeTable={recipeTable}
            values={values}
            orderId={orderId}
            orderNumber={orderNumber}
            session={session}
            change={(values) => change({ ...values })}
          />;
  }, [recipeTable, values]);

  const tabMenu = React.useMemo(() => {
    const multifocalRecipeType = values?.recipeType == RecipeType.Bifocal;

    if (!multifocalRecipeType) return null;

    return <TabMenu
      tabs={[
        {
          key: TabOptions.Diagnostic,
          text: strings.Diagnostic
        },
        {
          key: TabOptions.Muiltifocal,
          text: strings.Multifocal
        }
      ]}
      activeKey={activeTab}
      change={(key) => setActiveTab(key)}
    />;
  }, [activeTab, values]);

  const tab = React.useMemo(() => {
    const multifocalRecipeType = values?.recipeType == RecipeType.Bifocal;

    const tabItem = activeTab === TabOptions.Muiltifocal && multifocalRecipeType
      ? <TabMultifocal
          values={values}
          frames={frames}
          change={(values) => change({ ...values })}
        />
      : <TabDiagnostic
          values={values}
          change={(values) => change({ ...values })}
        />;

    if (!multifocalRecipeType) {
      return <>{tabItem}</>;
    }

    return <TabItem>{tabItem}</TabItem>;
  }, [activeTab, values]);

  const body = React.useMemo(() => {
    return <BodyContainer>
            {tabMenu}
            {tab}
          </BodyContainer>;
  }, [tabMenu, tab]);

  return (
    <>
      {header}
      {body}
    </>
  );
}

export { RegisterRecipeForm };